import ReportProfileForm from '@/core/components/ProfileActions/ReportProfileForm/ReportProfileForm';

export default ReportProfileForm;
